// extracted by mini-css-extract-plugin
export var content = "_ox-1";
export var fullScreen = "_ox-0";